module.exports = __webpack_public_path__ + "static/img/icon-house-map.6c496e5c.png";